<template>
  <el-dialog
    v-drag
    v-loading="loading"
    title="更新状态"
    :visible.sync="dialogVisible"
    width="500px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="content">
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择" style="width: 100%;">
            <el-option
              v-for="item in config.importerStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="footers flex_c_c">
      <div class="cancel flex_c_c" @click="cancel">取消</div>
      <div v-debounce-click="{ value: ok, args: ['form'] }" class="ok flex_c_c">
        确定
      </div>
    </span>
  </el-dialog>
</template>

<script>
import { batchUpdateStatus } from '@/api/system'
import config from '@/utils/config'
export default {
  props: {
    dialogVisible: Boolean,
    selectionItem: Array
  },
  data() {
    return {
      config,
      loading: false,
      form: {
        status: ''
      },
      rules: {
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  watch: {
    dialogVisible(v) {
      if (v) {
        this.reset()
      }
    }
  },
  methods: {
    reset() {
      this.form = this.$options.data().form
      this.$refs.form?.resetFields()
    },
    cancel() {
      this.$emit('cancel')
    },
    ok(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          this.loading = true
          try {
            const params = {
              importerIds: this.selectionItem.map(a => a.id),
              ...this.form
            }
            const res = await batchUpdateStatus(params)
            this.loading = false
            if (res.success) {
              this.$message.success(res.errorMessage)
              this.$emit('ok')
            } else {
              this.$message.error(res.errorMessage)
            }
          } catch (error) {
            this.loading = false
            console.error(error)
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: calc(100% - 40px);
  margin: 0 auto;
  /deep/ .el-form--label-top .el-form-item__label {
    line-height: 30px;
    padding: 0;
  }
}
.footers {
  width: 100%;
  & > div {
    width: 120px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }
  .cancel {
    background: #eeeeee;
    color: #666666;
    margin-right: 16px;
  }
  .ok {
    background: #142e79;
    color: #ffffff;
  }
}
</style>
